import { z } from 'zod';
import { errorMap } from 'zod-validation-error';

import { deepCopy, getErrorKeys, removeKeysFromObject } from '../optionsSchemaUtils';
import { PaymentMethodSelectorElementOptions } from './PaymentMethodSelectorElement';

const DISPLAY_MODES = ['full-screen', 'container'] as const;

export const PaymentMethodSelectorOptionsSchema = z.object({
  recipientId: z.string().trim().min(1),
  amount: z.number(),
  country: z.string().trim().min(1),
  displayMode: z.enum(DISPLAY_MODES).optional()
});

export const parsePaymentMethodSelectorOptions = (options: PaymentMethodSelectorElementOptions) => {
  const mandatoryResult = PaymentMethodSelectorOptionsSchema.safeParse(options, { errorMap });
  const initialOptions = deepCopy(options);

  if (
    !mandatoryResult.success &&
    (mandatoryResult.error.flatten().fieldErrors['recipientId'] ||
      mandatoryResult.error.flatten().fieldErrors['amount'] ||
      mandatoryResult.error.flatten().fieldErrors['country'])
  ) {
    return { errors: mandatoryResult.error.errors };
  }

  const errorKeys = getErrorKeys(mandatoryResult.error?.errors || []);
  const sanitizedOptions = removeKeysFromObject(options, errorKeys);

  return !mandatoryResult.success
    ? {
        warnings: mandatoryResult.error.flatten().fieldErrors,
        options: sanitizedOptions as PaymentMethodSelectorElementOptions,
        initialOptions
      }
    : {
        options: mandatoryResult.data as PaymentMethodSelectorElementOptions,
        initialOptions
      };
};
